import { render, staticRenderFns } from "./accountConf.vue?vue&type=template&id=60656c0b&scoped=true&"
import script from "./accountConf.vue?vue&type=script&lang=js&"
export * from "./accountConf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60656c0b",
  null
  
)

export default component.exports